import HOST from './host';

const SIGN = `${ HOST }/sign`;

const API = {

  sign: {

    in:    `${ SIGN }/in`,
    check: `${ SIGN }/check`,

  },

}

export default API;